<form class="edit-form" *ngIf="!isLoading && holidayGroups" [formGroup]="editForm" (submit)="onSubmit()">

  <mat-form-field class="start-date-field">
    <mat-label>Date</mat-label>
    <input matInput formControlName="date" [matDatepicker]="datePicker">
    <mat-datepicker-toggle matSuffix [for]="datePicker"></mat-datepicker-toggle>
    <mat-datepicker #datePicker></mat-datepicker>
  </mat-form-field>


  <mat-form-field>
    <mat-label>{{ 'billing.holidays.edit.description.label' | translate }}</mat-label>
    <input type="text" matInput formControlName="description">
    <mat-error>{{ 'billing.holidays.edit.description.errorMessage' | translate }}</mat-error>
  </mat-form-field>

  <app-autocomplete [control]="getControl('group')" [list]="holidayGroups" label="billing.holidays.edit.group.label"
    errorMsg="billing.holidays.edit.group.errorMessage">
  </app-autocomplete>

  <app-validate-and-cancel (submitEvent)="endForm($event)" [editForm]="editForm" class="actions"
    [disabling]="editForm.invalid"></app-validate-and-cancel>
</form>
<mat-spinner *ngIf="isLoading" [diameter]="35" color="primary"></mat-spinner>
